<template>
  <div id="tools" class="fixed-content">
    <tabs :transition="0" v-model="tab">
      <tab title="Fiches techniques">
        <techSheets :list="techSheets" title="Fiches techniques">
          <template slot="intro">
            <alert type="warning">
              <p class="text-center">
                <strong>
                  Les documents présents sur cette page sont en accord avec les
                  recommandations nationales en vigueur.
                </strong>
              </p>
            </alert>
          </template>
        </techSheets>
      </tab>
      <tab title="Outils pédagogiques">
        <educational />
      </tab>
      <tab title="Supports de formation">
        <techSheets :list="trainingSheets"
                    tools="trainingTools"
                    title="Supports de formation">
          <template slot="intro">
            <lily-component
              :contents="trainingTools.ktReco.content"
              :open="trainingTools.ktReco.collapse"
              id="training-tools-ktReco">
            </lily-component>
            <hr>
          </template>
        </techSheets>
      </tab>
    </tabs>
  </div>
</template>
<script>
import sc from '@/sc/tools'
import techSheets from '@/components/tools/techSheets'
import educational from '@/components/tools/educational'
import pageSection from '@/components/pagesection'
import lilyComponent from '@/components/tools/lily'
import lilySc from '@/sc/lily'

export default {
  components: {
    techSheets,
    educational,
    'page-section': pageSection,
    'lily-component': lilyComponent
  },

  name: 'tools',

  data: function () {
    const tab = parseInt(this.$route.query.tab)
    return {
      tab: (isNaN(tab)) ? 0 : tab,
      techSheets: sc.files.techsheets,
      trainingSheets: sc.files.trainingSheets,
      trainingTools: {
        ktReco: {
          content: lilySc.ktReco,
          collapse: true
        }
      }
    }
  },

  watch: {
    '$route.query.tab': function (v) {
      const t = parseInt(v)
      this.tab = (isNaN(t)) ? 0 : t
    }
  }
}
</script>
